import Navbar from '../components/Navbar';
import HeroCanvas from '../components/HeroCanvas';
import Sections from '../components/Sections';
import Footer from '../components/Footer';

export default function Landing() {
  return (
    <>
      <Navbar />
      <main>
        {/* mode="frames" + framePathPattern, or mode="video" + videoSrc, both work —
            procedural is the zero-asset default (master guide §8.3) */}
        <HeroCanvas mode="procedural" />
        <Sections />
      </main>
      <Footer />
    </>
  );
}
